import { DataValidator, IsBoolean, Required, transformKeys } from "@/utils/type-vaildator";
import api from "./api"; 

interface agentUserDeleteAudioTemplateResponse {
  isUsed: boolean,
}

class agentUserDeleteAudioTemplateData {
  @IsBoolean("isUsed must be a boolean")
  isUsed: boolean;
}

const transformAndValidateData = (
  response: agentUserDeleteAudioTemplateResponse
): agentUserDeleteAudioTemplateData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, agentUserDeleteAudioTemplateData);
  } catch (error) {
    console.error("Agent user delete audio template data validation failed:", error.message);
    throw error;
  }
};

// 删除智能体用户音频（播客音频）
export const agentUserDeleteAudioTemplate = async ({
  audioId,
  userId,
  agentId,
}: {
  audioId: string,
  userId: string,
  agentId: string,
}) => {
  const res = await api.post<agentUserDeleteAudioTemplateResponse>("/agent/user/delete-audio-template", {
    audio_id: audioId,
    user_id: userId,
    agent_id: agentId,
  });
  return transformAndValidateData(res.data);
};
